import {MutableRefObject, useEffect} from 'react'; // Hook

const useOnClickOutside = (ref: MutableRefObject<any>, handler: (event: MouseEvent | TouchEvent) => void) => {
	useEffect(() => {
		const listener: (this: Document, ev: MouseEvent | TouchEvent) => any = (event: MouseEvent | TouchEvent) => {
			// Do nothing if clicking ref's element or descendent elements
			if (!ref.current || ref.current.contains(event.target)) {
				return;
			}

			handler(event);
		};

		document.addEventListener('mousedown', listener);
		document.addEventListener('touchstart', listener);

		return () => {
			document.removeEventListener('mousedown', listener);
			document.removeEventListener('touchstart', listener);
		};
	}, [ref, handler]);
};

export default useOnClickOutside;
